import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { DateTime } from 'luxon';
import { RootState } from '../../../../../../../../store/root-reducer';
import ReportsSubHeader from './reports-sub-header';
import type { CallDirectionFilter, ReportFilters } from './reports-sub-header';

interface IProps {
  onExport?: () => void | Promise<void>;
  onDetailedExport?: () => void | Promise<void>;
  callDirection: CallDirectionFilter;
  onCallDirectionChange: (direction: CallDirectionFilter) => void;
  onFiltersChange?: (filters: ReportFilters) => void;
  selectedUserIds?: number[];
}

const ReportsSubHeaderContainer: React.FC<IProps> = memo(
  ({
    onExport,
    onDetailedExport,
    callDirection,
    onCallDirectionChange,
    onFiltersChange,
    selectedUserIds = [],
  }) => {
    const timeZone = useSelector(
      (state: RootState) =>
        state?.myProfile?.myProfile?.timeZone || DateTime.local().zoneName,
    );
    const isDemoAccount = useSelector(
      (state: RootState) => state?.home?.isDemoAccount,
    );

    return (
      <ReportsSubHeader
        timeZone={timeZone}
        onExport={onExport}
        onDetailedExport={onDetailedExport}
        callDirection={callDirection}
        onCallDirectionChange={onCallDirectionChange}
        onFiltersChange={onFiltersChange}
        selectedUserIds={selectedUserIds}
        isDemoAccount={isDemoAccount}
      />
    );
  },
);

export default ReportsSubHeaderContainer;
